<div class="form">
  <div class="description subtitle">
    {{ 'AUTOMATIONS.EDITOR.TRIGGERS.WHOLESALE_PURCHASE_CREATED.DESCRIPTION' | translate }}
  </div>
  <glxy-select-input
    [formControl]="statusControl"
    [required]="true"
    [options]="options"
    [value]="statusControl.value"
  ></glxy-select-input>
  <mat-radio-group [formControl]="allProductsControl">
    <div>
      <mat-radio-button [checked]="disableProductSelection$ | async" [value]="ANY_PRODUCT">
        {{ 'AUTOMATIONS.EDITOR.TRIGGERS.WHOLESALE_PURCHASE_CREATED.ANY_PRODUCT_CAPITAL' | translate }}
      </mat-radio-button>
    </div>
    <div>
      <mat-radio-button [checked]="(disableProductSelection$ | async) === false" [value]="SELECT_PRODUCT">
        {{ 'AUTOMATIONS.EDITOR.TRIGGERS.WHOLESALE_PURCHASE_CREATED.SELECT_PRODUCT' | translate }}
      </mat-radio-button>
    </div>
  </mat-radio-group>
</div>
<div *ngIf="disableProductSelection$ | async">
  <p>
    {{ 'AUTOMATIONS.EDITOR.TRIGGERS.WHOLESALE_PURCHASE_CREATED.NOTE' | translate }}
  </p>
</div>
<div class="content">
  <div class="form" *ngIf="(disableProductSelection$ | async) === false">
    <ng-container *ngIf="appOptions$ | async as appOptions; else loading">
      <EXP__glxy-wrap>
        <mat-form-field>
          <mat-label>
            {{ 'AUTOMATIONS.EDITOR.TRIGGERS.WHOLESALE_PURCHASE_CREATED.SELECT_PRODUCT' | translate }}
          </mat-label>
          <mat-select [formControl]="productControl" multiple>
            <mat-select-trigger>
              {{ productControl.value?.length > 0 ? (getProductNameFromString(productControl.value[0]) | async) : '' }}
              <span *ngIf="productControl.value?.length > 1">
                (+{{ productControl.value.length - 1 }}
                {{
                  (productControl.value?.length === 2
                    ? 'AUTOMATIONS.EDITOR.FILTERS.OTHER'
                    : 'AUTOMATIONS.EDITOR.FILTERS.OTHERS'
                  ) | translate
                }})
              </span>
            </mat-select-trigger>
            <mat-option *ngFor="let app of appOptions" [value]="app.value">
              {{ app.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </EXP__glxy-wrap>
    </ng-container>
  </div>
</div>

<ng-template #loading>
  <div class="side-drawer-shimmer-container">
    <span class="selector stencil-shimmer"></span>
  </div>
</ng-template>
